import React, { useEffect, useState } from 'react'
import { formatBytes } from '../../../../utils/commonFunction';
import { handleDownloadAssessment } from '../../../common/DownloadAssessment';

function DownloadModalComponent({ children, modalId, downloadRef, zipName, type, assId, payload,apiUrl }) {
  const [FinalLoadedData, setFinalLoadedData] = useState(0)
  const [finalTotal, setFinalTotal] = useState(0);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    return () => {
      setFinalLoadedData(0);
      setFinalTotal(0);
      setIsDownloading(false);
    };
  }, []);

  return (
    <>
      <span onClick={() => { handleDownloadAssessment(payload, setFinalLoadedData, setFinalTotal, modalId, zipName, setIsDownloading,apiUrl) }}>
        {children}
      </span>
      {isDownloading ? <div className="downloading-progress modal fade show d-block" id={modalId} tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" ref={downloadRef} data-backdrop="static">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <div className="swal2-header">
                <div className="swal2-icon swal2-info swal2-icon-show d-flex">
                  <div className="swal2-icon-content">i</div>
                </div>
                <h2 className="swal2-title d-flex mb-4">Downloading...</h2>
                <div className="progress w-100 mb-2">

                  <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow={FinalLoadedData && finalTotal > 0 ? (FinalLoadedData / finalTotal * 100).toFixed(1) : 0} aria-valuemin="0" aria-valuemax="100" style={{ width: FinalLoadedData && finalTotal > 0 ? `${(FinalLoadedData / finalTotal * 100).toFixed(1)}%` : `0%` }}>
                    {FinalLoadedData && finalTotal > 0 ? (FinalLoadedData / finalTotal * 100).toFixed(2) : 0}%</div>
                </div>
                <div>
                  File Size: {finalTotal > 0
                    ? `${formatBytes(FinalLoadedData, 1)} / ${formatBytes(finalTotal, 1)}`
                    : `0 / 0`}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> : null}
    </>
  )
}

export default DownloadModalComponent